// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import EnglishTranslation from './Component/Locals/en/EnglishTranslation.json';
import MarathiTranslation from './Component/Locals/mr/MarathiTranslation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: EnglishTranslation,
      },
      mr: {
        translation: MarathiTranslation,
      },
    },
    lng: 'mr',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
